module.exports = __webpack_public_path__ + "static/img/null.cedad70.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/null.jpeg
// module id = 0DVM
// module chunks = 17